// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a0ead307","286":"7df4b85c","316":"b85bf32c","508":"8b9f3395","682":"7612c756","980":"fe18a9f5"}[chunkId] + ".chunk.js";
};